import { useState } from "react";
import { useLocation } from "react-router-dom";
import classes from "./BottomPageSearch.module.css"
import Button from "../HomePage/Button";

const BottomPageSearch = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const [activeOption, setActiveOption] = useState('Alle'); 

    const buttonArray = [
        { key: 1, text: 'Fotostudio' },
        { key: 2, text: 'Musik' },
        { key: 3, text: 'Video' },
        { key: 4, text: 'Kunst' },
        { key: 5, text: 'Design' },
        { key: 6, text: 'Schreiben' },
        { key: 7, text: 'Tanzen' },
        { key: 8, text: 'Teater' },
        { key: 9, text: 'Mode' },
        { key: 10, text: 'Handwerk' },
      ];

    const handleOptionClick = (option) => {
      setActiveOption(option);
    };
  
    return (
        <div className={classes.searchContainer}>  </div>
        // <div className={classes.searchContainer}>
        //     {!params.get('activity') && !params.get('location') ?
        //         <div className={classes.firstOptionsContainer}>
        //             <button
        //                 className="mediumLarge"

        //                 style={{
        //                 background: activeOption === 'Alle' ? 'var(--light-black)' : 'var(--light-grey-2)',
        //                 color: activeOption === 'Alle' ? 'white' : 'inherit',}} onClick={() => handleOptionClick('Alle')}
        //             >
        //                 Alle
        //             </button>
        //             <button
        //                 className="mediumLarge"
        //                 style={{
        //                 background: activeOption === 'Musik' ? 'var(--light-black)' : 'var(--light-grey-2)',
        //                 color: activeOption === 'Musik' ? 'white' : 'inherit',
        //                 }}
        //                 onClick={() => handleOptionClick('Musik')}
        //             >
        //                 Musik
        //             </button>
        //             <button
        //                 className="mediumLarge"
        //                 style={{
        //                 width: '115px',
        //                 background: activeOption === 'Foto & Video' ? 'var(--light-black)' : 'var(--light-grey-2)',
        //                 color: activeOption === 'Foto & Video' ? 'white' : 'inherit',
        //                 }}
        //                 onClick={() => handleOptionClick('Foto & Video')}
        //             >
        //                 Foto & Video
        //             </button>
        //         </div>
        //     :
        //     <div className={classes.timeFilterContainer}>
        //         <div className={classes.timeDiv}>
        //             <button className={classes.dateTimeButton}>
        //                 <span style={{ display: "inline-block" }} className="mediumSmall">Datum & Zeit</span>
        //                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
        //                     <path d="M18.5081 18.0005H1.49194C0.671205 18.0005 0 17.3632 0 16.5769V2.56232C0 1.77598 0.671205 1.13867 1.49194 1.13867H18.5081C19.3288 1.13867 20 1.77916 20 2.56232V16.5769C20 17.3632 19.3288 18.0005 18.5081 18.0005ZM1.49194 2.18818C1.27596 2.18818 1.09985 2.35622 1.09985 2.56232V16.5769C1.09985 16.783 1.27596 16.951 1.49194 16.951H18.5081C18.724 16.951 18.9002 16.783 18.9002 16.5769V2.56232C18.9002 2.35622 18.724 2.18818 18.5081 2.18818H1.49194Z" fill="#1F1F1F"/>
        //                     <path d="M10.551 0H9.45117V3.21827H10.551V0Z" fill="#1F1F1F"/>
        //                     <path d="M15.2424 0H14.1426V3.21827H15.2424V0Z" fill="#1F1F1F"/>
        //                     <path d="M5.87133 0H4.77148V3.21827H5.87133V0Z" fill="#1F1F1F"/>
        //                 </svg>
        //             </button>
        //             <div className={classes.smallLine}></div>
        //         </div>
        //         <div className={classes.tagsContainer}>
        //             {buttonArray.map(button => (
        //                 <Button key={button.key} text={button.text} />
        //             ))}
        //         </div>
        //     </div>
        //     }
        // </div>
    );

  };
  
  export default BottomPageSearch;
  